module.exports = "<app-navbar></app-navbar>\n<!-- <app-navbartwo></app-navbartwo> -->\n<app-providerregister></app-providerregister>"